import type { NextPage } from 'next'
import { Materials } from '@/client/modules/Materials'
import { MaterialsProps } from '@/client/modules/Materials/types'
import { getCMSContent } from '@/client/utils'

const MaterialsPage: NextPage<MaterialsProps> = (data) => <Materials {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'MATERIALS')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default MaterialsPage
